import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row ">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/portrait.jpg" className="img-responsive" style={{width:'100%', height:'auto', marginBottom:20}} alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{props?.data?.title}</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>{props?.data?.question}</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
